<template>
  <a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
      <div class="row no-gutters">
        <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <base-input alternative="" label="As of"
                  ><br />
                  <a-date-picker
                    v-model="inputDate"
                    format="MM-DD-YYYY"
                    placeholder="Start Date"
                    style="width: 100%"
                  />
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <base-input alternative="" label="Select Sales Channel">
                  <a-select
                    mode="multiple"
                    v-model="inputSalesChannel"
                    showSearch
                    placeholder="All Sales Channel"
                    optionFilterProp="children"
                    style="width: 100%"
                    :filterOption="filterOption"
                  >
                    <a-select-option
                      v-for="option in salesChannelOptions"
                      :key="option.id"
                      :value="option.id"
                      >{{ option.name }}</a-select-option
                    >
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <base-input label="Sort By">
                  <select
                    v-if="inputFormat == '1'"
                    class="form-control"
                    size="large"
                    v-model="inputSortBy"
                    @click.prevent="autoChange"
                  >
                    <option
                      v-for="option in sortOptions"
                      v-bind:value="option.key"
                      v-bind:key="option.key"
                    >
                      {{ option.value }}
                    </option>
                  </select>
                  <select
                    v-else
                    class="form-control"
                    size="large"
                    v-model="inputSortExtendedBy"
                    @click.prevent="autoChange"
                  >
                    <option
                      v-for="option in sortExtendedOptions"
                      v-bind:value="option.key"
                      v-bind:key="option.key"
                    >
                      {{ option.value }}
                    </option>
                  </select>
                </base-input>
              </div>
              <div class="col-md-2 mt-3 pt-3">
                <button
                  type="button"
                  class="btn btn-sm btn-link"
                  @click="showSortInfoDiv"
                >
                  {{ showSortInfo == "asc" ? "Ascending (A-Z) ↡" : "Descending (Z-A) ↟" }}
                </button>
              </div>
            </div>

            <base-checkbox class="mb-3" v-model="isShowDecimal">
              Show decimal
            </base-checkbox>

            <!-- <div class="row">
              <div class="col-md-4">
                <button
                  class="btn btn-sm"
                  style="background-color: #394a5d; color: white"
                  @click.prevent="advanceFilter(true)"
                >
                  {{ toggleLabel }}
                </button>
              </div>
            </div> -->
            <div class="row">
              <div class="col-md-12">
                <br />
                <!-- <button
                    class="btn btn-sm btn-default float-right"
                    style="border-radius: 24px; border: 0px; width: 20%"
                    @click.prevent="generateReport"
                  >
                    Generate Report in PDF
                  </button> -->
                &nbsp; &nbsp;
                <button
                  v-if="JsonData.length < 1"
                  class="btn btn-sm btn-default float-right"
                  style="border-radius: 24px; border: 0px; width: 20%"
                  @click.prevent="generateFile"
                >
                  Generate Report
                </button>
                &nbsp; &nbsp;
                <vue-json-to-csv
                  v-if="JsonData.length > 0"
                  :json-data="JsonData"
                  :csv-title="
                    currentProfile.replace(/_/g, '-') + '-' + currDate.replace(/ /g, '_')
                  "
                >
                  <button
                    id="clickCsvExport"
                    class="btn btn-sm btn-success float-right"
                    style="border-radius: 24px; border: 0px; width: 20%"
                  >
                    Download CSV
                  </button>
                  &nbsp; &nbsp;
                </vue-json-to-csv>
                <download-excel
                  v-if="JsonData.length > 0"
                  :data="JsonData"
                  :name="
                    currentProfile.replace(/_/g, '-') +
                    '-' +
                    currDate.replace(/ /g, '')
                  "
                  type="xlsx" 
                  class="float-right"
                  style="width: 20%"
                >
                  <button
                    class="btn btn-sm btn-success"
                    style="border-radius: 24px; border: 0px; width: 100%"
                    @click.prevent="clearJsonData"
                  >
                    Download excel
                  </button>
                  &nbsp; &nbsp;
                </download-excel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
        <a-drawer
          title=""
          width="500"
          placement="right"
          @close="closeFilter"
          :visible="advancedFilterVisible"
        >
          <advance-filter
            :parentParams="advancedFilterParams"
            @changeParams="changeParams"
            @closeFilter="closeFilter"
          ></advance-filter>
        </a-drawer>
      </div>
    </div>
  </a-spin>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import secureStorage from "../../controllers/secureStorage";
import reportUtils from "../../components/reportUtils";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import VueJsonToCsv from "vue-json-to-csv";
import AdvanceFilter from "../Bir Reports/ReportAdvanceFilter";

import { mapState } from "vuex";

var component_x;

export default {
  props: {
    withCost: { type: Boolean },
  },
  data() {
    return {
      spinning: false,
      inputDate: moment().endOf("day"),
      inputSalesChannel: [],
      sales_channel_type: [],
      salesChannelOptions: [],
      inputSortBy: "stock_no",
      sortOptions: [
        { key: "stock_no", value: "MFG Code" },
        { key: "barcode", value: "Barcode" },
        { key: "name", value: "Name or Description" },
        { key: "onhand_qty", value: "On-Hand Quantity" },
      ],

      inputFormat: "1",
      isShowDecimal: false,
      salesChannelSalesChannel: false,
      birSalesReports: [],

      currDate: moment().format("L_LT").split(":").join(";"),
      showSortInfo: "asc",
      JsonData: [],
      toggleAdvanceFilter: false,
      toggleLabel: "Advanced Filter",
      advancedFilterParams: {},
      params: {},
      advancedFilterVisible: true,
      reportData: [],
      totalPerGrpOnHand: 0,
      totalPerGrpPriceXQty: 0,
      totalPerGrpAvailable: 0,
      totalPerGrpLandedCost: 0,
    };
  },
  mounted: async function () {
    component_x = this;

    var sales_channels = await HTTPRequest.getRequest(
      component_x.endPoint + "sales_channels?status=A",
      null
    );

    component_x.salesChannelOptions = sales_channels["data"];
    component_x.sort(component_x.salesChannelOptions);
  },
  computed: {
    ...mapState(["currentProfile", "endPoint"]),
  },
  components: {
    AdvanceFilter,
    VueJsonToCsv,
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Advanced Info
    showSortInfoDiv() {
      this.showSortInfo == "asc"
        ? (this.showSortInfo = "desc")
        : (this.showSortInfo = "asc");
    },
    autoChange(e) {
      if (this.inputFormat == "1") {
        this.inputSortExtendedBy = this.inputSortBy;
      } else {
        if (
          e.target.value == "stock_no" ||
          e.target.value == "barcode" ||
          e.target.value == "name" ||
          e.target.value == "available_qty" ||
          e.target.value == "onhand_qty"
        ) {
          this.inputSortBy = this.inputSortExtendedBy;
        } else {
          this.inputSortBy = "stock_no";
        }
      }
    },
    sort(data) {
      data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    convertToCurrency(num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    advanceFilter(value) {
      this.toggleAdvanceFilter = value;
      if (this.toggleAdvanceFilter == true) {
        this.toggleLabel = "Collapse Filter";
      } else {
        this.toggleLabel = "Advanced Filter";
      }
    },
    closeFilter() {
      this.advanceFilter(false);
    },
    changeParams(params, actualParams, mode) {
      this.params = params;
      this.advancedFilterParams = actualParams;

      if (mode == "filter") {
        this.advanceFilter(false);
      }
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    requestEcommInventory: async function () {
      let sorting = this.inputSortBy;
      if (this.inputFormat == "2") {
        sorting = this.inputSortExtendedBy;
      }

      let parameters = {
        sales_channel_id: this.inputSalesChannel.toString(),
        as_of: this.inputDate.format("YYYY-MM-DD HH:mm:ss"),
        group: this.inputGroupBy,
        order: sorting,
        by: this.showSortInfo,
        isSeparate: this.salesChannelSalesChannel,
        display: this.inputDisplay,
        advanced_filter: this.params,
      };

      let getRequest = await HTTPRequest.getRequest(
        this.endPoint + "ecomm_inventory_reports?",
        parameters
      );

      return getRequest;
    },
    setPerGroupTotal(isPDF = false) {
      let perGroupArr = [];

      if (this.isShowDecimal == false) {
        this.totalPerGrpOnHand = this.formatNumber(this.totalPerGrpOnHand);
        this.totalPerGrpAvailable = this.formatNumber(this.totalPerGrpAvailable);
      } else {
        this.totalPerGrpOnHand = this.convertToCurrency(this.totalPerGrpOnHand);
        this.totalPerGrpAvailable = this.convertToCurrency(this.totalPerGrpAvailable);
      }

      // Set Total Per Group
      perGroupArr.push(
        "",
        "",
        "Group Sub Total :",
        this.totalPerGrpAvailable,
        this.totalPerGrpOnHand,
        "",
        this.convertToCurrency(this.totalPerGrpPriceXQty)
      );

      // Set Total Per Group (Extended)

      if (isPDF) {
        this.reportData.push(Object.assign({}, ["rowLine"]));
      }
      this.reportData.push(perGroupArr);

      // Set all total per group to zero
      this.totalPerGrpOnHand = 0;
      this.totalPerGrpPriceXQty = 0;
      this.totalPerGrpAvailable = 0;
    },
    generateReport: async function () {
      this.spinning = true;
      this.reportData = [];

      if (this.inputDate.length == 0) {
        reportUtils.openNotificationWithIcon(
          component_x,
          "error",
          "Please make sure to check your current filters."
        );
        return;
      }

      let as_of = this.inputDate.format("MMMM DD, YYYY");

      let get_request = await this.requestEcommInventory();

      if (get_request.error) {
        reportUtils.openNotificationWithIcon(component_x, "error", get_request.error);
        return;
      }
      let salesChannelSpecific = get_request;
      if (salesChannelSpecific.length > 0) {
        let doc = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "legal",
        });

        // let reportLogo = document.getElementById("reportLogo");
        // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

        let headers = [];

        let header_detail = [];

        header_detail.push(
          { content: "Stock #", styles: { halign: "center" } },
          { content: "Barcode", styles: { halign: "center" } },
          { content: "Description", styles: { halign: "center" } },
          { content: "Available\n(Pcs)", styles: { halign: "center" } },
          { content: "On-hand\n(Pcs)", styles: { halign: "center" } },
          { content: "Price\n(SRP)", styles: { halign: "center" } },
          { content: "Total Price\n(SRP)", styles: { halign: "center" } }
        );

        headers = [header_detail];
        let grand_onhand_qty = 0;
        let grand_price_x_qty = 0;
        let grand_available_qty = 0;
        let product_array = [];

        for (let x = 0; x < salesChannelSpecific.length; x++) {
          this.birSalesReports = salesChannelSpecific[x].report_details;

          if (x > 0 && this.birSalesReports.length > 0) {
            doc.addPage();
          }

          if (this.birSalesReports.length > 0) {
            let grouper = "start";

            let total_onhand_qty = 0;
            let total_price_x_qty = 0;
            let total_available_qty = 0;

            for (let i = 0; i < this.birSalesReports.length; i++) {
              let reportLine = this.birSalesReports[i];
              let grouper_name = reportLine.grouper_name;

              let available_qty = Number(reportLine.available_qty);
              let onhand_qty = Number(reportLine.onhand_qty);
              if (this.isShowDecimal == false) {
                onhand_qty = parseInt(reportLine.onhand_qty);
                available_qty = parseInt(reportLine.available_qty);
              }

              if (product_array.includes(reportLine.product_id) == false) {
                product_array.push(reportLine.product_id);
              }

              if (grouper == "start") {
                let detail_header = [
                  {
                    content: grouper_name,
                    colSpan: 3,
                    styles: { halign: "left", fontStyle: "bold" },
                  },
                ];
                this.reportData.push(Object.assign({}, detail_header));
              } else {
                if (grouper != reportLine.grouper_id) {
                  this.setPerGroupTotal(true);

                  let detail_header = [
                    {
                      content: grouper_name,
                      colSpan: 3,
                      styles: { halign: "left", fontStyle: "bold" },
                    },
                  ];
                  this.reportData.push(Object.assign({}, detail_header));
                }
              }
              grouper = reportLine.grouper_id;

              let price_x_qty = onhand_qty * Number(reportLine.price);

              let available_qty_display = this.convertToCurrency(available_qty);
              let onhand_qty_display = this.convertToCurrency(onhand_qty);
              if (this.isShowDecimal == false) {
                onhand_qty_display = this.formatNumber(onhand_qty);
                available_qty_display = this.formatNumber(available_qty);
              }

              let detail = [];
              detail = [
                reportLine.stock_no,
                reportLine.barcode,
                { content: reportLine.name, styles: { halign: "left" } },
                available_qty_display,
                onhand_qty_display,
                this.convertToCurrency(Number(reportLine.price)),
                this.convertToCurrency(price_x_qty),
              ];

              total_available_qty += available_qty;
              total_onhand_qty += onhand_qty;
              total_price_x_qty += price_x_qty;

              this.totalPerGrpOnHand += onhand_qty;
              this.totalPerGrpPriceXQty += price_x_qty;

              grand_onhand_qty += onhand_qty;
              grand_price_x_qty += price_x_qty;

              this.reportData.push(Object.assign({}, detail));

              let sub_detail = [];
              if (i == this.birSalesReports.length - 1) {
                let total_onhand_display = this.convertToCurrency(total_onhand_qty);

                let total_available_display = this.convertToCurrency(total_available_qty);

                let grand_onhand_display = this.convertToCurrency(grand_onhand_qty);
                let grand_available_display = this.convertToCurrency(grand_available_qty);

                if (this.isShowDecimal == false) {
                  total_onhand_display = this.formatNumber(total_onhand_qty);
                  total_available_display = this.formatNumber(total_available_qty);

                  grand_onhand_display = this.formatNumber(grand_onhand_qty);
                  grand_available_display = this.formatNumber(grand_available_qty);
                }

                this.setPerGroupTotal(true);

                if (this.isSeparateSite == true) {
                  sub_detail = [
                    "",
                    "",
                    "SalesChannel Sub Total :",
                    total_available_display,
                    total_onhand_display,
                    "",
                    this.convertToCurrency(total_price_x_qty),
                  ];

                  this.reportData.push(Object.assign({}, ["rowLine"]));
                  this.reportData.push(Object.assign({}, sub_detail));
                } else {
                  //Grand Total
                  this.reportData.push(Object.assign({}, ["rowLine"]));

                  let grand_detail = [
                    "Assortment: ",
                    product_array.length,
                    "Grand Total :",
                    grand_available_display,
                    grand_onhand_display,
                    "",
                    this.convertToCurrency(grand_price_x_qty),
                  ];
                  this.reportData.push(Object.assign({}, grand_detail));
                }
              }
            }
          }

          if (x == salesChannelSpecific.length - 1) {
            if (this.isSeparateSite == true) {
              let grand_onhand_display = this.convertToCurrency(grand_onhand_qty);
              let grand_available_display = this.convertToCurrency(grand_available_qty);

              if (this.isShowDecimal == false) {
                grand_onhand_display = this.formatNumber(grand_onhand_qty);
                grand_available_display = this.formatNumber(grand_available_qty);
              }

              //Grand Total
              this.reportData.push(Object.assign({}, ["rowLine"]));

              let grand_detail = [
                "Assortment: ",
                product_array.length,
                "Grand Total :",
                grand_available_display,
                grand_onhand_display,
                "",
                this.convertToCurrency(grand_price_x_qty),
              ];
              this.reportData.push(Object.assign({}, grand_detail));
            }
          }

          let group_text = "";
          if (this.inputGroupBy != "") {
            group_text =
              " by " + this.groupOptions.find((x) => x.key === this.inputGroupBy).value;
          }

          doc.setFontSize(14);
          doc.setFontType("bold");
          doc.text(15, 20, "Ecomm Inventory Report" + group_text);
          doc.setFontType("normal");
          doc.setFontSize(10);

          let sales_channel_text = "";
          if (this.inputSalesChannel.length == 0) {
            sales_channel_text = "All Sales Channel";
          } else {
            let sales_channels = this.inputSalesChannel;
            for (var s = 0; s < sales_channels.length; s++) {
              if (s == 0) {
                sales_channel_text += this.salesChannelOptions.find(
                  (x) => x.id === sales_channels[s]
                ).name;
              }
            }
          }
          doc.text(340, 20, sales_channel_text, "right");

          doc.text(15, 25, "As of " + as_of);

          let desc_width = 85;

          if (this.inputFormat == "1" && !this.withCost) {
            desc_width = 175;
          } else if (this.inputFormat == "2" && this.withCost) {
            desc_width = 50;
          }

          let colStyles = {};
          colStyles = {
            0: { cellWidth: 30 },
            1: { cellWidth: 30 },
            2: { cellWidth: desc_width },
            3: { cellWidth: 30 },
            4: { cellWidth: 30 },
            5: { cellWidth: 30 },
            6: { cellWidth: 30 },
          };

          doc.autoTable({
            startY: 35,
            head: headers,
            body: this.reportData,
            theme: "plain",
            tableWidth: "wrap",
            headStyles: {
              lineWidth: 0.15,
              cellPadding: 2,
            },
            styles: {
              cellPadding: 1.0,
              fontSize: 10,
              halign: "right",
            },
            margin: { bottom: 30 },
            columnStyles: colStyles,
            didParseCell: function (data) {
              if (data.row.section == "body" && data.row.raw[0] == "rowLine") {
                data.cell.styles.fillColor = [0, 0, 0];
                data.cell.styles.fontSize = 1;
                data.cell.styles.cellPadding = 0;
              } else if (
                data.row.section == "body" &&
                [
                  "Grand Total :",
                  "SalesChannel Sub Total :",
                  "Group Sub Total :",
                ].includes(data.row.raw[2])
              ) {
                data.cell.styles.fontStyle = "bold";
              }
            },
          });
          let printed_by = secureStorage.getItem("email");
          if (printed_by == null) {
            printed_by = "";
          }

          let pageCount = doc.internal.getNumberOfPages();

          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            reportUtils.pdfTools.addFooter(
              doc,
              printed_by,
              "Ecomm Inventory Report" + group_text,
              340,
              200,
              i,
              pageCount
            );
          }
        }

        window.open(URL.createObjectURL(doc.output("blob")));
      } else {
        reportUtils.openNotificationWithIcon(
          component_x,
          "error",
          "Please make sure to check your current filters."
        );
      }
      this.spinning = false;
    },
    generateFile: async function () {
      this.spinning = true;
      this.reportData = [];

      if (this.inputDate.length == 0) {
        reportUtils.openNotificationWithIcon(
          component_x,
          "error",
          "Please make sure to check your current filters."
        );
        return;
      }

      let get_request = await this.requestEcommInventory();

      if (get_request.error) {
        reportUtils.openNotificationWithIcon(component_x, "error", get_request.error);
        return;
      }
      let salesChannelSpecific = get_request;

      if (get_request.length > 0) {
        let headers = [];
        let saleschannel_specific = [];
        let header_detail = [];

        header_detail.push(
          "Stock #",
          "Barcode",
          "Description",
          "Available\n(Pcs)",
          "On-hand\n(Pcs)",
          "Price\n(SRP)",
          "Total Price\n(SRP)"
        );

        headers = header_detail;
        let grand_onhand_qty = 0;
        let grand_price_x_qty = 0;
        let grand_available_qty = 0;
        let product_array = [];
        for (let x = 0; x < salesChannelSpecific.length; x++) {
          this.birSalesReports = salesChannelSpecific[x].report_details;

          if (this.birSalesReports.length > 0) {
            let grouper = "start";

            let total_onhand_qty = 0;
            let total_price_x_qty = 0;
            let total_available_qty = 0;

            for (let i = 0; i < this.birSalesReports.length; i++) {
              let reportLine = this.birSalesReports[i];
              let grouper_name = reportLine.grouper_name;

              let available_qty = Number(reportLine.available_qty);
              let onhand_qty = Number(reportLine.onhand_qty);
              if (this.isShowDecimal == false) {
                onhand_qty = parseInt(reportLine.onhand_qty);
                available_qty = parseInt(reportLine.available_qty);
              }

              if (product_array.includes(reportLine.product_id) == false) {
                product_array.push(reportLine.product_id);
              }

              if (grouper == "start") {
                let detail_header = [grouper_name];
                this.reportData.push(detail_header);
              } else {
                if (grouper != reportLine.grouper_id) {
                  this.setPerGroupTotal();

                  let detail_header = [grouper_name];
                  this.reportData.push(detail_header);
                }
              }
              grouper = reportLine.grouper_id;

              let price_x_qty = onhand_qty * Number(reportLine.price);
              let available_qty_display = this.convertToCurrency(available_qty);

              let onhand_qty_display = this.convertToCurrency(onhand_qty);
              if (this.isShowDecimal == false) {
                onhand_qty_display = this.formatNumber(onhand_qty);
                available_qty_display = this.formatNumber(available_qty);
              }

              let detail = [];
              detail = [
                reportLine.stock_no,
                reportLine.barcode,
                reportLine.name,
                onhand_qty_display,
                available_qty_display,
                this.convertToCurrency(Number(reportLine.price)),
                this.convertToCurrency(price_x_qty),
              ];
              total_available_qty += available_qty;
              total_onhand_qty += onhand_qty;
              total_price_x_qty += price_x_qty;

              this.totalPerGrpAvailable += available_qty;
              this.totalPerGrpOnHand += onhand_qty;
              this.totalPerGrpPriceXQty += price_x_qty;

              grand_available_qty += available_qty;
              grand_onhand_qty += onhand_qty;
              grand_price_x_qty += price_x_qty;

              this.reportData.push(Object.assign({}, detail));

              let sub_detail = [];
              if (i == this.birSalesReports.length - 1) {
                let total_onhand_display = this.convertToCurrency(total_onhand_qty);
                let total_available_display = this.convertToCurrency(total_available_qty);

                let grand_onhand_display = this.convertToCurrency(grand_onhand_qty);
                let grand_available_display = this.convertToCurrency(grand_available_qty);

                if (this.isShowDecimal == false) {
                  total_onhand_display = this.formatNumber(total_onhand_qty);
                  total_available_display = this.formatNumber(total_available_qty);

                  grand_onhand_display = this.formatNumber(grand_onhand_qty);
                  grand_available_display = this.formatNumber(total_available_qty);
                }

                this.setPerGroupTotal();

                if (this.isSeparateSite == true) {
                  sub_detail = [
                    "",
                    "",
                    "SalesChannel Sub Total :",
                    total_available_display,
                    total_onhand_display,
                    "",
                    this.convertToCurrency(total_price_x_qty),
                  ];

                  this.reportData.push(Object.assign({}, sub_detail));
                } else {
                  //Grand Total

                  let grand_detail = [
                    "Assortment: ",
                    product_array.length,
                    "Grand Total :",
                    grand_available_display,
                    grand_onhand_display,
                    "",
                    this.convertToCurrency(grand_price_x_qty),
                  ];
                  this.reportData.push(Object.assign({}, grand_detail));
                }
              }
              //
            }
          }

          let group_text = "";
          if (this.inputGroupBy != "") {
            group_text = " by " + this.sortOptions[0].value;
          }

          let printed_by = secureStorage.getItem("email");
          if (printed_by == null) {
            printed_by = "";
          }

          this.reportData.push([
            "Ecomm Inventory Report" + group_text,
            "Generate By: " + printed_by,
          ]);
        }

        let keys = headers;
        let values = this.reportData;
        var values_length = values.length;

        let newJsonData = [];

        // change headers and report data as key and value object
        for (var i = 0; i < values_length; i++) {
          var result = Object.assign.apply(
            {},
            keys.map((val, index) => ({
              [val]: values[i][index],
            }))
          );
          newJsonData.push(result);
        }

        // change undefined on arr
        newJsonData.forEach(function (obj) {
          for (var i in obj) {
            if (obj[i] === undefined || obj[i] === null) {
              obj[i] = "";
            }
          }
        });
        saleschannel_specific.push(newJsonData);
        // for each site specific[] convert nested to single array
        this.JsonData = saleschannel_specific.flat(Infinity);
      } else {
        reportUtils.openNotificationWithIcon(component_x, "error", "No Data.");
      }
      // console.log(this.reportData);
      this.spinning = false;
    },
    clearJsonData() {
      // console.log("working",this.JsonData)
      this.JsonData = [];
    },
  },
};
</script>

<style></style>
